<template>
  <div id="info">
    <table>
      <tbody>
        <tr>
          <th>ご予約方法</th>
          <td class="newline">{{ reserv }}</td>
        </tr>
        <tr>
          <th>保険について</th>
          <td class="newline">{{ guarantee }}</td>
        </tr>
        <tr>
          <th>乗船上のご注意事項;</th>
          <td class="newline number">
            {{ cautionTitleText }}
            <ol>
              <li
                v-for="item in caution"
                :key="item.cautionText"
                class="newline"
              >
                {{ item.cautionText }}
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    reserv: Text,
    guarantee: Text,
    cautionTitleText: Text,
    caution: Object,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/privateCruising/cruisingInfo.scss";
</style>
